import { useEffect, useRef, useState } from "react";

export function useInvoicePdfTemplateSettings<Template extends string, Result>({
  savedValue,
  canEdit,
  save,
  onSaved,
}: {
  savedValue: Template | undefined;
  canEdit: boolean;
  save: (value: Template) => Promise<Result>;
  onSaved: (result: Result) => void;
}) {
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  const [selection, setSelection] = useState<Template | null>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const value = selection ?? savedValue;

  async function submit() {
    if (!savedValue || !value || !canEdit || saving) return;
    setSaving(true);
    setError(null);
    try {
      const result = await save(value);
      if (!active.current) return;
      onSaved(result);
      setSelection(null);
    } catch (error) {
      if (!active.current) return;
      setError(
        error instanceof Error
          ? error.message
          : "Could not save the invoice PDF template. Please try again.",
      );
    } finally {
      if (active.current) setSaving(false);
    }
  }

  return { value, setSelection, saving, error, submit };
}
